export const pageWithoutShipmentProgress = [
  'shipment-print',
  'shipment-return',
  'shipment-success',
];
